
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/static_page",
      function () {
        return require("private-next-pages/static_page.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/static_page"])
      });
    }
  